(function(){
  function init(root){
    var b=root.querySelector('[data-menu]'),n=root.querySelector('[data-nav]');
    if(b&&n&&!b.dataset.on){b.dataset.on=1;b.addEventListener('click',function(){n.classList.toggle('open')})}
    root.querySelectorAll('[data-hero]').forEach(function(h){
      if(h.dataset.on)return;h.dataset.on=1;
      var s=h.querySelectorAll('.slide'),d=h.querySelectorAll('[data-dot]'),i=0,t;
      function go(k){i=(k+s.length)%s.length;s.forEach(function(e,j){e.classList.toggle('on',j===i)});d.forEach(function(e,j){e.classList.toggle('on',j===i)})}
      d.forEach(function(e,j){e.addEventListener('click',function(){go(j);play()})});
      function play(){clearInterval(t);if(s.length>1&&h.dataset.auto==='1'&&!(window.Shopify&&Shopify.designMode)){t=setInterval(function(){go(i+1)},6000)}}
      play();
    });
    root.querySelectorAll('[data-gal]').forEach(function(g){
      if(g.dataset.on)return;g.dataset.on=1;
      var sl=g.querySelectorAll('[data-slide]'),th=g.querySelectorAll('[data-thumb]');
      th.forEach(function(t){t.addEventListener('click',function(){
        var k=t.getAttribute('data-thumb');
        sl.forEach(function(e){e.classList.toggle('on',e.getAttribute('data-slide')===k)});
        th.forEach(function(e){e.classList.toggle('on',e===t)});
      })});
    });
    root.querySelectorAll('[data-sort]').forEach(function(s){
      s.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',s.value);u.searchParams.delete('page');location.href=u.toString()});
    });
  }
  document.addEventListener('DOMContentLoaded',function(){init(document)});
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
